import { Checkbox, Tag, Tooltip } from "antd";
import { fmtDateTimeFull, getSortedUniqueValues } from "../extensions/utils";

export const getLogUserResult = (result) => {
  switch (result) {
      case 0: return <Tag color="#87d068">OK</Tag>;
      case 1: return <Tag color="#f50">ERROR</Tag>;
      case 2: return <Tag color="orange">WARNING</Tag>;
      default: return result;
  }    
}

export const productVids = [
  { value: 0, label: "Товар" },
  { value: 1, label: "Услуга" },
  { value: 2, label: "Абонемент" },
  { value: 3, label: "Пакет" },
  { value: 4, label: "Сертификат" },
]

export const getProductVidName = id => productVids.find(i => i.value === id)?.label;

export const productMarkVids = [
  { value: 0, label: "Нет" },
  { value: 1, label: "QR код маркировки" },
  { value: 2, label: "GTIN" },
]

export const productMarkVidsMobile = [
  { value: 0, label: "Нет" },
  { value: 1, label: "QR-код" },
  { value: 2, label: "GTIN" },
]

export const clientVids = [
  { value: 0, label: "Физ.лицо", icon: "/images/physicalClient.svg" },
  { value: 1, label: "Юр. лицо", icon: "/images/organisation.svg" },
]


export const dateVids = [
  { value : 0, label: "Дата" },
  { value : 1, label: "Активация" },
  { value : 2, label: "Окончание" },
]

export const salesStatuses = [
  { value: 0, label: "Неопределен" },
  { value: 1, label: "Новый" },
  { value: 2, label: "Активен" },
  { value: 3, label: "Заморожен" },
  { value: 4, label: "Разморожен" },
  { value: 5, label: "Закрыт" },
]

export const clientTypeFilter = [
  { value: 0, label: " " },
  { value: 1, label: "Активные" },
  { value: 2, label: "Спящие" },
  { value: 3, label: "Потерянные" },
  { value: 4, label: "Лояльные" },
  { value: 5, label: "Потенциальные" },
]

export const paymentsVids = [
  { value: -1, label: "Возврат" },
  { value: 1, label: "Оплата" },
  { value: 2, label: "Пополнение"},
  { value: 11, label: "X отчет" },
  { value: 12, label: "Z отчет" },
]

export const getPaymentVids = vid => paymentsVids.find(item => item.value === vid);
export const getPaymentVidName = vid => paymentsVids.find(item => item.value === vid)?.label;

export const statusColorMap = {
  0: "#d9d9d9",   // серый
  1: "#faad14",   // жёлтый (неактивен)
  2: "#52c41a",   // зелёный (активен)
  3: "#1890ff",   // синий (заморожен)
  4: "#52c41a",   // разморожен (активен)
  5: "#f5222d",   // красный (закрыт)
};

export const licenseStatusColorMap = {
  0: "#d9d9d9", //новый
  1: "#faad14", //оплачен
  2: "#52c41a", //активен
  3: "#f5222d", //закрыт
  4: "#f5222d", //отменен
};

export const renderStatusCircle = (value) => {
  const color = statusColorMap[value] || "#ccc";
  const title = salesStatuses.find((s) => s.value === value)?.label || "";

  return (
    <div title={title} style={{
      width: 12,
      height: 12,
      borderRadius: "50%",
      backgroundColor: color,
      margin: "0 auto",
    }} />
  );
};

export const getStatusColor = (value, record) => {
  if (record?.deleted || record?.blocked)
    return "#f5222d";

  return statusColorMap[value];
};

export const getLicenseStatusColor = (value, record) => {
  return licenseStatusColorMap[value];
};

export const renderStatusIcon = (value, record) => {
  const title = salesStatuses.find((s) => s.value === value)?.label || "";

  if (record?.deleted) {
    return (
      <img
        src="/images/abon-deleted.svg"
        alt="Удалён"
        title="Удалён"
        style={{ width: 20, height: 20, display: "block", margin: "0 auto" }}
      />
    );
  }

  if (record?.blocked) {
    return (
      <img
        src="/images/abon-locked.svg"
        alt="Заблокирован"
        title="Заблокирован"
        style={{ width: 20, height: 20, display: "block", margin: "0 auto" }}
      />
    );
  }

  const iconMap = {
    0: "/images/status-unactive-gray.png",
    1: "/images/status-unactive.png",
    2: "/images/status-active.png",
    3: "/images/status-freezed.png",
    4: "/images/status-active.png",
    5: "/images/status-closed.png",
  };

  const iconSrc = iconMap[value];

  if (!iconSrc) return null;

  return (
    <img
      src={iconSrc}
      alt={title}
      title={title}
      style={{ width: 20, height: 20, display: "block", margin: "0 auto" }}
    />
  );
};

export const datPeriodVids = [
  { value: 0, label: " "},
  { value: 1, label: "День" },
  { value: 31, label: "Месяц" },
  { value: 365, label: "Год" },
];

export const getDatPeriodVidName = (value) => datPeriodVids.find((i) => i.value === value)?.label;

export const getTableColumn = (
  fieldName,
  title,
  { type = "string", valueList, width, render, isSorter = false, isFilter = false, customFilter, formatFn, valueFn, defaultSortOrder, ellipsis, buttons} = {},
  dataSource
) => {
  const column = { dataIndex: fieldName, title, width, ellipsis };

  if (defaultSortOrder) {
    column.defaultSortOrder = defaultSortOrder;
  }

  // Sorter
  if (isSorter) {
    column.sorter = (a, b) => {
      const valA = a[fieldName];
      const valB = b[fieldName];
      if (type === "number") return valA - valB;
      if (type === "date") return new Date(valA) - new Date(valB);
      return String(valA).localeCompare(String(valB));
    };
  }

  // Render
  if (render) {
    if (type === "number") {
      column.render = (...args) => {
        const result = render(...args);
        return <div style={{ textAlign: "right" }}>{result}</div>;
      };
    } else {
      column.render = render;
    }
  } else if (buttons) {
    column.render = (_value, record) => (
      <div style={{ display: "flex", gap: 8 }}>
        {buttons.map(({ icon, onClick, alt, width = 12, tooltip }, index) => (
          <img key={index} src={icon} width={width} alt={alt} title={tooltip || alt} className="img-edit-btn" onClick={() => onClick(record)} style={{ cursor: "pointer" }}/>
        ))}
      </div>
    );
  } else if (type === "date") {
    column.render = (value) => formatFn?.(value) || value;
  } else if (type === "number") {
    column.render = (value) => (
      <div style={{ textAlign: "right" }}>{value}</div>
    );
  } else {
    column.render = (value) => value;
  }

  // Filters
  if (isFilter){
    if (valueList) {
      column.filters = valueList.map((v) =>
        typeof v === "object" ? v : { text: v, value: v }
      );
    } else if (dataSource) {
      column.filters = getSortedUniqueValues(dataSource, fieldName, { type, formatFn, valueFn });
    }

  // onFilter
    if (customFilter) {
      column.onFilter = customFilter;
    } else {
      column.onFilter = (value, record) => {
        const recordValue = valueFn?.(record[fieldName]) || (type === "date" ? new Date(record[fieldName]).toISOString().split("T")[0] : record[fieldName]);
        return recordValue === value;
      };
    }
  }

  column.printable = {
    title,
    dataIndex: fieldName,
    renderPrint: (val) =>
      type === "date" ? formatFn?.(val) || val : val,
  };

  return column;
};

export const saleStatuses = [
  { value: 0, label: " ", color: "#000" },
  { value: 1, label: "Новый", color: "#888" },
  { value: 2, label: "Активный", color: "#2f6f00" },
  { value: 3, label: "Заморожен", color: "#137cb9" },
  { value: 4, label: "Закрыт", color: "#f00" },
]

export const getSaleStatusName = id => saleStatuses.find(i => i.value === id)?.label;

export const getSaleStatusTag = id => <Tag color={saleStatuses.find(i => i.value === id)?.color}>{getSaleStatusName(id)}</Tag>

export const daysOfWeek = [
  { value: 1, label: "Понедельник" },
  { value: 2, label: "Вторник" },
  { value: 3, label: "Среда" },
  { value: 4, label: "Четверг" },
  { value: 5, label: "Пятница" },
  { value: 6, label: "Суббота" },
  { value: 7, label: "Воскресенье" },
]

export const getDayOfWeekName = (day) => daysOfWeek.find(i => i.value === day)?.label;

export const months = [
  { value: 1, label: "Январь" },
  { value: 2, label: "Февраль" },
  { value: 3, label: "Март" },
  { value: 4, label: "Апрель" },
  { value: 5, label: "Май" },
  { value: 6, label: "Июнь" },
  { value: 7, label: "Июль" },
  { value: 8, label: "Август" },
  { value: 9, label: "Сентябрь" },
  { value: 10, label: "Октябрь" },
  { value: 11, label: "Ноябрь" },
  { value: 12, label: "Декабрь" },
]

export const getMonthName = (month) => months.find(i => i.value === month)?.label;

/** Добавляет в Select регистронезависимую фильтрацию по label
 * @param {string} input строка поиска
 * @param {SelectOption} option элемент списка
 * @see Пример использования <Select ... filterOption={selectFilterOption}/>
*/
export const selectFilterOption = (input, option) => option.label?.toLowerCase().indexOf(input?.toLowerCase()) >= 0 || option.label?.toLowerCase().indexOf(input?.toLowerCase()) >= 0

/** Вхождение первой строки во вторую регистронезависимое */
export const hasSubstring = (searchStr, fullStr) => {
  if (!searchStr) return true;
  if (!fullStr) return false;
  return fullStr.toLowerCase().indexOf(searchStr.toLowerCase()) >= 0;
}

export const syncStatuses = [
  { value: 1, label: "Новый", color: "orange" },
  { value: 2, label: "OK", color: "#87d068" },
  { value: 3, label: "Ошибка", color: "#f50" },
]

export const getSyncStatusName = id => syncStatuses.find(i => i.value === id)?.label;
export const getSyncStatusColor = id => syncStatuses.find(i => i.value === id)?.color;

/** Отрисовка колонки СТАТУС СИНХРОНИЗАЦИИ в таблице 
 * @param {Объект { status, errorMessage, syncDateTime }} item код статуса
 * @param {Number} status ID статуса
 * @param {string} errorMessage текст ошибки при неудачной синхронизации - появляется хинтом
 * @param {string} syncDateTime строка дата время последней синхронизации
 * @return {Tag} Цветовой тэг с наименованием статуса и хинтом включающим syncDateTime и errorMessage если они не пустые
*/
export const renderSyncStatus = ({ status, errorMessage, syncDateTime }) => {
  const statusObj = syncStatuses.find(i => i.value === status);
  if (!statusObj) return null;
  const text = `${syncDateTime ? fmtDateTimeFull(syncDateTime) : ""}
  ${errorMessage ? errorMessage : ""}`.trim();
  return  <Tooltip title={text}><Tag color={statusObj.color}>{statusObj.label}</Tag></Tooltip>
}

/** Отрисовка колонки ССЫЛКА в таблице
 * @param {string} url код статуса
 * @return {JSX.Element} Кликабельная ссылка
*/
export const renderUrl = url => url ? <a href={url} target="_blank" rel="noreferrer">Ссылка</a> : null

/** Отрисовка галочки в таблице
 * @param {bool} value значение
 */
export const renderCheckbox = value => <Checkbox checked={value} />

/** Виды фискализации кассы */
export const fiscalVids = [
  { value : 0, label: "Не фискальная" },
  { value : 1, label: "Наличные" },
  { value : 2, label: "Карта" },
  { value : 11, label: "Онлайн карта" },
  { value : 12, label: "Онлайн QR" },
  { value : 13, label: "Онлайн кредит" },
  { value : 14, label: "Онлайн спец." },
  { value : 21, label: "Депозит" },
  { value : 22, label: "Сертификат" },
  { value : 23, label: "Бонус" },
]

/** Банки для вида оплаты */
export const paymentVidBanks = [
  { value: 0, label: "Нет" },
  { value: 1, label: "ТБанк" },
  { value: 2, label: "Сбербанк" },
]

export const discalVidName = value => fiscalVids.find(i => i.value === value)?.label;

/** Виды складских накладных */
export const storeDocVids = [
  { value: 1, label: "Приход" },
  { value: -1, label: "Расход" },
  { value: 2, label: "Инвентаризация" },
]

export const storeDocVidName = value => storeDocVids.find(i => i.value === value)?.label;

/** Варианты лимитов по количеству посещений */
export const productLimitVisit = [
  { value: 0, label: "Всего" },
  { value: 1, label: "В день" },
  { value: 7, label: "В неделю" },
]

export const productLimitVisitName = value => productLimitVisit.find(i => i.value === value)?.label;


export const userRoles = [
  { value: 0, label: "Администратор системы" },
  { value: 10, label: "Менеджер-Администратор" },
  { value: 20, label: "Специалист" },
]

export const getUserToleName = value => userRoles.find(i => i.value === value)?.label;

// Order statuses
export const orderStatuses = [
  { value: 0, label: "Новый" },
  { value: 1, label: "Оплачен" },
  { value: 2, label: "Активен" },
  { value: 3, label: "Закрыт" },
  { value: 4, label: "Отменен" },
];

// Ticket statuses
export const ticketStatuses = [
  { value: 0, label: "" },
  { value: 1, label: "Новый" },
  { value: 2, label: "Ок" },
  { value: 3, label: "Ошибка" },
];

export const getOrderStatusName = value => orderStatuses.find(i => i.value === value)?.label;

// Tariff kinds
export const tariffKinds = [
  { value: 0, label: "Отсутствует" },
  { value: 1, label: "Базовая версия" },
];

export const getTariffKindName = value => tariffKinds.find(i => i.value === value)?.label;

// Srok vids (period types)
export const srokVids = [
  { value: 0, label: "Нет" },
  { value: 1, label: "День" },
  { value: 2, label: "Месяц" },
  { value: 3, label: "Год" },
];

export const getSrokVidName = value => srokVids.find(i => i.value === value)?.label;

// Message directions
export const messageDirections = [
  { value: 0, label: "Не определено" },
  { value: 1, label: "Входящее" },
  { value: 2, label: "Исходящее" },
];

export const getMessageDirectionName = value => messageDirections.find(i => i.value === value)?.label;

// Message pattern vids
export const messagePatternVids = [
  { value: 0, label: "Вручную" },
  { value: 1, label: "После регистрации" },
  { value: 2, label: "После активации пробного периода" },
  { value: 3, label: "Перед окончанием пробного периода" },
  { value: 4, label: "После выписки счёта на оплату" },
  { value: 5, label: "После оплаты счёта" },
  { value: 6, label: "Перед блокировкой аккаунта" },
  { value: 7, label: "После блокировки аккаунта" },
];

export const getMessagePatternVidName = value => messagePatternVids.find(i => i.value === value)?.label;